import { apiSlice } from "../../../../services";
import { IApiIdReq } from "../../../../types/interfaces";
import { IAmazeKeyRes, IGetFbFanPageBotsReq } from "../../types";
import { ICreateFacebookAccReq, IFacebookFanPagesRes } from "../types";

export const botSettingsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // 是否已經綁定 fbFanPage
        getFbFanPageBot: builder.query<IFacebookFanPagesRes, IGetFbFanPageBotsReq>({
            query: (params) => ({
                url: "/facebook/get_record",
                // method: "GET",
                params,
            }),
            providesTags: ["FbAcc"],
        }),
        // 綁定facebook粉絲頁
        createFbAcc: builder.mutation<IAmazeKeyRes, ICreateFacebookAccReq>({
            query: (reqData) => ({
                url: "/facebook/create_record",
                method: "POST",
                body: { ...reqData },
            }),
            invalidatesTags: ["FbAcc"],
        }),
        // 解除綁定 facebook粉絲頁
        delFbAcc: builder.mutation<IAmazeKeyRes, IApiIdReq>({
            query: (reqData) => ({
                url: "/facebook/delete_record",
                method: "DELETE",
                body: { ...reqData },
            }),
            invalidatesTags: ["FbAcc"],
        }),
    }),
});

export const { useGetFbFanPageBotQuery, useCreateFbAccMutation, useDelFbAccMutation } = botSettingsApiSlice;
